import React, {PropsWithChildren, useContext, useEffect, useMemo, useState} from "react";
import {useConfig} from "../../config";
import VideoController from "../../unreal/VideoController";
import VisualizerSessionManager from "./VisualizerSessionManager";
import {IVisualizerManager} from "../../visualizers/VisualizerContext";


const VisualizerSessionContext = React.createContext<VisualizerSessionManager|null>(null);
const VisualizerStatusContext = React.createContext<IVisualizerStatus|null>(null);
const VideoPlayerControlContext = React.createContext<IVideoControls|null>(null);

export interface IVideoControls {
    setPaused(isPaused:boolean): void;
    seek(timeMillis:number, isRelative?: boolean): void;
}
class UnrealVideoControls implements IVideoControls {

    constructor(private readonly videoControls: VideoController) {

    }
    setPaused(isPaused:boolean): void {
        this.videoControls.paused(isPaused);
    }

    seek(timeMillis:number, isRelative?: boolean): void {
        this.videoControls.seek(timeMillis, isRelative);
    }

}

export function useVideoPlayerControls() {
    return useContext(VideoPlayerControlContext)!;
}
export function useVisualizerStatus() {
    return useContext(VisualizerStatusContext);
}
export function useVideoPlayerStatus() {
    const mediaStatus = useVisualizerStatus();
    if (mediaStatus === null) return null;
    const mediaDetails = mediaStatus.details;
    if (mediaDetails.type === "video") {

        return mediaDetails;
    }
    return null;
}
export function useVisualizerSession() {
    return useContext(VisualizerSessionContext)!;
}

class VideoControlAdapter implements IVideoControls {
    constructor(private readonly underlying: IVideoControls, private readonly onSetPaused:(isPaused:boolean) => void) {

    }
    setPaused(isPaused: boolean) {

        this.onSetPaused(isPaused);
        this.underlying.setPaused(isPaused);
    }
    seek(timeMillis: number, isRelative?: boolean) {
        this.underlying.seek(timeMillis, isRelative);
    }
}



export type IWebPageStatus = {
    type: "web"
}
export type IShow3DStatus = {
    type: "3d"
};

export type IVideoPlayerStatus = {
    type: "video",
    isPlaying: boolean;

    file: string;
    title: string;
    looping: boolean;

}

export interface IVisualizerStatus {
    sessionId: string;
    details: IVideoPlayerStatus | IWebPageStatus | IShow3DStatus;
}



export const VscVisualizerSession: React.FC<PropsWithChildren<{visualizer: IVisualizerManager}>> = (props) => {


    const [isConnected, setIsConnected] = useState<boolean>(false);

    const [visualizerStatus, setVisualizerStatus] = useState<IVisualizerStatus | null>(null);

    const visualizer = props.visualizer;
    const videoPlayerStatusDetails = visualizerStatus?.details.type === "video" && visualizerStatus.details;


    const visualizerSessionManager = useMemo(() => new VisualizerSessionManager((details) => {

        console.log('setting visualizer status!');
        setVisualizerStatus(details);

    }, visualizer), []);
    visualizerSessionManager.connect().then(() => {
        if (!isConnected) {
            setIsConnected(true);
        }
    });


    console.log('render VscVisualizerSession');
    console.log(visualizerStatus);
    const videoControls = useMemo(() => {
        console.log(visualizerStatus);
        if (videoPlayerStatusDetails === false) return null;

        const vc = new VideoController(visualizerStatus!.sessionId, visualizerSessionManager.getMessageSender());
        const unrealVideoControls = new UnrealVideoControls(vc);
        const adapterSetPaused = (paused: boolean) => setVisualizerStatus(old => {
            if (old === null) return null;
            const oldVideoDetails = old.details;
            if (oldVideoDetails.type !== "video") return old;


            return (
                {...old, details: {...oldVideoDetails, type: 'video', isPlaying: !paused}})
        });

        const videoControlAdapter = new VideoControlAdapter(unrealVideoControls, adapterSetPaused);
        return videoControlAdapter;

    }, [visualizerStatus?.sessionId]);

    if (!isConnected) {
        return <div>Connecting...</div>
    };
    return <VisualizerSessionContext.Provider value={visualizerSessionManager}>
        <VisualizerStatusContext.Provider value={visualizerStatus}>
            <VideoPlayerControlContext.Provider value={videoControls}>
                {props.children}
            </VideoPlayerControlContext.Provider>

        </VisualizerStatusContext.Provider>
    </VisualizerSessionContext.Provider>

}